import axios from 'axios'
import config from '../../data/config'
import * as ActionTypes from '../../constants/actions'

export const initialState = {
    api: {}
};

export default function api(state = initialState, action) {
    const { payload } = action;
    
    switch (action.type) {
        case ActionTypes.MAP_SHOW:
            const { from, to, avoid, options } = payload

            axios.post(config.api.saveSearch, options);

            return state

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/api/index.js